const initState = {
    data:[],
    result:false,
    nota:null,
    
    conexion: false,
    error: false,   
};

export default initState;